
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

import { sharedState } from '../../framework/state';
import { getFieldNameFromVModelProperty } from '../../framework/util/component_util';
import { RegistrationNumberMatch } from '../../../common/application/model/integration/finvoice/RegistrationNumberMatch';

@Component({
    components: { ValidationProvider },
})
export default class RegistrationNumberMatchSelect extends Vue {
    @Prop(String) readonly name!: string;
    @Prop(String) readonly value!: string;
    @Prop(String) readonly labelPosition!: string;
    @Prop(Array) readonly options!: RegistrationNumberMatch[];
    @Prop(Boolean) readonly required!: boolean;
    @Prop(Boolean) readonly horizontal!: boolean;
    @Prop(Boolean) readonly expanded!: boolean;
    @Prop(Boolean) readonly disabled!: string;

    shared = sharedState;
    local = {
        value: undefined as string | undefined,
    };

    async mounted() {
        if (this.options.length === 1 && this.options[0].matchQuality === 1) {
            this.local.value = this.options[0].value;
        }
        await this.modelValueChange(this.value);
    }

    @Watch('value')
    async modelValueChange(newValue: string) {
        this.local.value = newValue;
    }

    @Watch('local.value')
    async inputValueChange(newValue: string) {
        this.$emit('input', newValue);
    }

    getFieldName() {
        return getFieldNameFromVModelProperty(this);
    }

    getOptionClass(matchQuality: number): string {
        switch (matchQuality) {
            case 1:
                return 'has-text-success';
            default:
                return '';
        }
    }
}
